/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */


export const publicUrl = process.env.PUBLIC_URL;


/**
 * 
 * Loader images
 * 
 */

export const loaderGIF = publicUrl + "/static/icons/table/loader.gif";

/**
 * 
 * Door images using in home page and estate sale screen.
 * 
 */
export const doorOneImage = publicUrl + "/static/images/Door/door1.png";
export const doorTwoImage = publicUrl + "/static/images/Door/door2.png";
export const doorThreeImage = publicUrl + "/static/images/Door/door3.png";

/**
 * 
 * Register lcons
 * 
 */
export const googleRegister = publicUrl + "/static/images/Register/googlescm.png";
export const facebookRegister = publicUrl + "/static/images/Register/facebookscm.png";
export const appleRegister = publicUrl + "/static/images/Register/applescm.png";
export const userImage = publicUrl + "/static/images/Register/user_image.svg";
export const androidstore = publicUrl + "/static/images/Register/androidstore.png";
export const appstore = publicUrl + "/static/images/Register/appstore.png";
export const banner1 = publicUrl + "/static/images/Register/register1.jpg";
export const banner2 = publicUrl + "/static/images/Register/register2.png";
export const banner3 = publicUrl + "/static/images/Register/register3.png";
export const banner4 = publicUrl + "/static/images/Register/register4.png";

/**
 * 
 * Background images
 * 
 */
export const registerHome = publicUrl + "/static/images/Register/home.png";
export const homeBanner = publicUrl + "/static/images/Home/banner.jpeg";
export const sellWith = publicUrl + "/static/images/Home/sell_with.png";
export const sellOne = publicUrl + "/static/images/Home/sell_1.png";
export const sellTwo = publicUrl + "/static/images/Home/sell_2.png";
export const homeSofa = publicUrl + "/static/images/Home/Perfect-sale_new.png";
export const whoWeAre = publicUrl + "/static/images/Home/who.png";
export const howItWorks = publicUrl + "/static/images/Home/how.png";
export const ctbidsWhyShopLocation = publicUrl + "/static/images/Home/ctbids_why_shop_location.png";
export const ctbidsWhyShopHeart = publicUrl + "/static/images/Home/ctbids_why_show_heart.png";

/**
 * 
 * Home page images
 * 
 */
export const bottomSofaImage = publicUrl + "/static/images/Home/Bottom_1.png";
export const bottomEarthImage = publicUrl + "/static/images/Home/Bottom_2.png";
export const poweredByImage = publicUrl + "/static/images/Home/powered_by.svg";
export const poweredByImageForFooter = publicUrl + "/static/images/Home/powered_by_footer.svg";
export const sellWithUsBan = publicUrl + "/static/images/Home/sell_with_us_ban.png";
export const worthPoint = publicUrl + "/static/images/Home/Worth_point.png";
export const franchise = publicUrl + "/static/images/Home/franchise.png";

export const uniquefeatureImage =  publicUrl + "/static/images/Home/ctbids_unique_features.png";
export const youmakediffrence = publicUrl + "/static/images/Home/You_Make_a_Difference.png"
export const bgTransparantBlack = publicUrl + "/static/images/BackGround/background.png";
export const premiermemberAd = publicUrl + "/static/images/Home/premier_ad.jpg";
export const sustainshop = publicUrl + "/static/images/ss.png";
export const safesecure = publicUrl + "/static/images/sands.png";

//membership image
export const pmbanner = publicUrl + "/static/images/membership/pmbanner.webp";
export const membership = publicUrl + "/static/images/membership/vipmembership.png";
export const PremierDelivery = publicUrl + "/static/images/Premier-Delivery.png";
export const PremierService = publicUrl + "/static/images/Premier-Service.png";
export const PremierWorthPoint = publicUrl + "/static/images/Premier-WorthPoint.png";
export const PremierAFA = publicUrl + "/static/images/Premier-AFA.png";
export const distribution = publicUrl + "/static/images/distribution.png";
export const membershipicon = publicUrl + "/static/images/membership.png";
export const advisor = publicUrl + "/static/images/advisor.png";
export const ctbidspremier = publicUrl + "/static/logo/premiermember.png";
export const newsandstories = publicUrl + "/static/images/newsandstories.png";
export const newsandstories1 = publicUrl + "/static/images/newsandstories1.png";
export const aboutusbanner = publicUrl + "/static/images/aboutus.webp";
export const aboutusbanner1 = publicUrl + "/static/images/aboutus1.png";
export const aboutusWhatWeDo = publicUrl + "/static/images/aboutus-what-we-do.jpg";
export const aboutusWhatWeDo1 = publicUrl + "/static/images/aboutus-what-we-do1.jpg";
export const aboutusIcon1 = publicUrl + "/static/images/icon1.png";
export const aboutusIcon2 = publicUrl + "/static/images/icon2.png";
export const aboutusIcon3 = publicUrl + "/static/images/icon3.png";
export const aboutusPhilosophyimg = publicUrl + "/static/images/aboutus-img.jpg";
export const aboutusreivew = publicUrl + "/static/images/aboutus-review.jpg";
export const aboutusreivew1 = publicUrl + "/static/images/aboutus-review.webp";

// about us
export const aboutuscaptionimg1 = publicUrl + "/static/images/aboutus/image1.jpg";
export const aboutuscaptionimg2 = publicUrl + "/static/images/aboutus/image2.jpg";
export const aboutuscaptionimg3 = publicUrl + "/static/images/aboutus/image3.jpg";
export const aboutuscaptionimg4 = publicUrl + "/static/images/aboutus/image4.jpg";





/**
 * 
 * Top auth nav bar icons. White for inactive tab and dark for active tab.
 * 
 */
export const myAccountWhite = publicUrl + "/static/header/myaccount_white.png";
export const watchingWhite = publicUrl + "/static/header/watching_white.png";
export const biddingWhite = publicUrl + "/static/header/bidding_white.png";
export const wonWhite = publicUrl + "/static/header/won_white.png";
export const notWonWhite = publicUrl + "/static/header/notwon-white.png";
export const notificationWhite = publicUrl + "/static/header/notification_white.png";

export const myAccountDark = publicUrl + "/static/header/myaccount.png";
export const watchingDark = publicUrl + "/static/header/watching.png";
export const biddingDark = publicUrl + "/static/header/bidding.png";
export const wonDark = publicUrl + "/static/header/won.png";
export const notWonDark = publicUrl + "/static/header/notwon.png";
export const notificationDark = publicUrl + "/static/header/notification.png";
export const FavoriteDark = publicUrl + "/static/header/FavoriteDark.png";
export const FavoriteWhite = publicUrl + "/static/header/FavoriteWhite.png";

/**
 * 
 * Banner images
 * 
 */

export const bannerRed = publicUrl + "/static/images/Banner/Banner_1.png";
export const bannerBrown = publicUrl + "/static/images/Banner/Banner_2.png";
export const bannerBlue = publicUrl + "/static/images/Banner/Banner_3.png";
export const bannerIce = publicUrl + "/static/images/Banner/Banner_4.png";
export const ourstory = publicUrl + "/static/images/Banner/ourstory.png";
export const ctbidslogo = publicUrl + "/static/logo/CTBids_logo.png";
export const caringtransitionslogo =  publicUrl + "/static/logo/caringtransitions_logo.png";
export const ctlogo =  publicUrl + "/static/logo/ctlogo.png";
/**
 * 
 * Estate sale container images
 * 
 */


export const  roomImg = 
{
    "Living Room":publicUrl + "/static/images/rooms/Living Room.svg",
    "Kitchen & Dining":publicUrl + "/static/images/rooms/Kitchen & Dining.svg",
    "Office":publicUrl + "/static/images/rooms/Office.svg",
    "Bedroom":publicUrl + "/static/images/rooms/Bedroom.svg",
    "Garage":publicUrl + "/static/images/rooms/Garage.svg",
    "Entertainment Cave":publicUrl + "/static/images/rooms/Entertainment Cave.svg",
    "Laundry Storage":publicUrl + "/static/images/rooms/Laundry Storage.svg",
    "Patio & Lawn":publicUrl + "/static/images/rooms/Patio & Lawn.svg",
    "Barn":publicUrl + "/static/images/rooms/Barn.svg",
    "Kids Playroom":publicUrl + "/static/images/rooms/Kids Playroom.svg",
}

/**
 * 
 * Estate sale banner images
 * 
 */

export const saleBannerBrown = {
    bgImage: publicUrl + "/static/images/EstateSale/Banner/Banner_neon.jpg",
    iconImage: publicUrl + "/static/images/EstateSale/Banner/Banner_icon_1.png"
};
export const saleBannerBlue = {
    bgImage: publicUrl + "/static/images/EstateSale/Banner/Banner_steel.jpg",
    iconImage: publicUrl + "/static/images/EstateSale/Banner/Banner_icon_1.png"
};
export const saleBannerPink = {
    bgImage: publicUrl + "/static/images/EstateSale/Banner/Banner_berry.jpg",
    iconImage: publicUrl + "/static/images/EstateSale/Banner/Banner_icon_1.png"
};
export const saleBannerteel = {
    bgImage: publicUrl + "/static/images/EstateSale/Banner/Banner_teel.jpg",
    iconImage: publicUrl + "/static/images/EstateSale/Banner/Banner_icon_1.png"
};
export const saleBannersky = {
    bgImage: publicUrl + "/static/images/EstateSale/Banner/Banner_sky.jpg",
    iconImage: publicUrl + "/static/images/EstateSale/Banner/Banner_icon_1.png"
};
export const saleBannernavy = {
    bgImage: publicUrl + "/static/images/EstateSale/Banner/Banner_navy.jpg",
    iconImage: publicUrl + "/static/images/EstateSale/Banner/Banner_icon_1.png"
};



/**
 * 
 * Item type images
 * 
 */

export const bidIcon = publicUrl + "/static/icons/table/bid.svg";
export const directIcon = publicUrl + "/static/icons/table/direct.svg";
export const onsiteIcon = publicUrl + "/static/icons/table/onsite.svg";
export const shippable = publicUrl + "/static/icons/common-icons/shippable.svg";
export const nonShippable = publicUrl + "/static/icons/common-icons/non_shippable.svg";


/**
 * 
 * Common Image 
 *  
 */
// export const image_thumbnail = publicUrl + "/static/images/image_thumbnail.png"; //old thumbnail image
export const image_thumbnail = publicUrl + "/static/images/Ctbidsdefault.png";
export const noSale = publicUrl + "/static/images/Home/nosale.png";
export const loaderIcon = publicUrl + "/static/icons/common-icons/loader_icon.gif";
export const appleSafariIcon = publicUrl + "/static/images/apple_safari-icon.svg";
export const firefoxIcon = publicUrl + "/static/images/firefox-icon.svg";
export const googleChromeIcon = publicUrl + "/static/images/google_chrome-icon.svg";
export const atmCardImg = publicUrl + "/static/images/atm-card.png";
export const earthImg = publicUrl + "/static/images/earth.png";
export const shiledImg = publicUrl + "/static/images/shield.png";
export const ctbids = publicUrl + "/static/images/ctbids.png";
export const heartImg = publicUrl + "/static/images/heart.png";
export const new_image_thumbnail = publicUrl + "/static/images/Ctbidsdefault.png";

/**
 * 
 * About page 
 * 
 */
export const MaskGroup512 = publicUrl + "/static/images/whoWeAre/MaskGroup512.png";
export const MaskGroup513 = publicUrl + "/static/images/whoWeAre/MaskGroup513.png";
export const MaskGroup514 = publicUrl + "/static/images/whoWeAre/MaskGroup514.png";

export const Group9158 = publicUrl + "/static/images/whoWeAre/Group9158.png";
export const Group9159 = publicUrl + "/static/images/whoWeAre/Group9159.png";
export const Group9160 = publicUrl + "/static/images/whoWeAre/Group9160.png";
export const Group9161 = publicUrl + "/static/images/whoWeAre/Group9161.png";


export const logobid = publicUrl + "/static/images/logobid.png";
export const timetable = publicUrl + "/static/images/sneakPeekNavy.png";
export const sneakPeekBerry = publicUrl + "/static/images/sneakPeekBerry.png";
export const sneakpreview = publicUrl + "/static/images/membership.png";
export const check = publicUrl + "/static/images/check-mark.png";
export const premierServiceBerry = publicUrl + "/static/images/Premier-service-berry.png";
export const premierAdvisorBerry = publicUrl + "/static/images/advisor.png";
export const bidBIcon = publicUrl +  "/static/icons/common-icons/bidicon.svg";

export const homeBg = publicUrl +  "/static/images/homebg.webp";
export const homeCard1 = publicUrl +  "/static/images/homecard.webp";
export const homeCard2 = publicUrl +  "/static/images/homecard2.jpg";
export const bottomcard = publicUrl +  "/static/images/bottomcard.jpg";
export const contentimg = publicUrl +  "/static/images/contentimg.jpg";
export const iPhone14 = publicUrl +  "/static/images/iPhone14.webp";

